<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <span class="fw-bold text-secondary">{{
        tabelaLancamento[0].ds_mensagem_liberacao
      }}</span>
      <div class="table-responsive font-size-12 m-auto">
        <b-table
          responsive="sm"
          :fields="camposLancamento"
          :items="tabelaLancamento"
          hover
          foot-clone
        >
          <template v-slot:cell(vl_lcto)="data">
            <span :class="data.value < 0 ? 'text-danger' : 'text-primary'">{{
              $tools.converteReal(data.value)
            }}</span>
          </template>
          <template v-slot:cell(cd_evento)="data">
            <span>{{ data.value }} - {{ data.item.ds_detalhado }}</span>
          </template>
          <template #foot()="">
            <h6></h6>
          </template>
          <template #foot(vl_lcto)="">
            <div class="text-end">
              <span class="text-dark fw-bold"
                >TOTAL: {{ $tools.converteReal(somaLancamentos) }}
              </span>
            </div>
          </template>
        </b-table>
      </div>

      <div>
        <b-form-group label="Selecione UMA das opções para crédito:">
          <b-form-radio
            @input="desabilitaAutorizacao()"
            v-model="selectedCredito"
            value="I"
            plain
            v-if="matricula && evento"
            >Integralização TOTAL na minha Conta Capital na
            cooperativa</b-form-radio
          >
          <b-form-radio v-model="selectedCredito" value="C" plain
            >Crédito TOTAL em conta bancária de minha titularidade</b-form-radio
          >
          <b-form-radio
            v-model="selectedCredito"
            value="P"
            plain
            v-if="matricula && evento"
            >Integralização parcial de 50% em Conta Capital e 50% em Crédito em
            conta bancária</b-form-radio
          >
        </b-form-group>

        <div
          class="table-responsive font-size-12 m-auto"
          v-if="selectedCredito != 'I' && selectedCredito != ''"
        >
          <b-table
            responsive="sm"
            :fields="camposContas"
            :items="tabelaContas"
            hover
          >
            <template v-slot:cell(details)="data">
              <b-form-radio
                v-model="selectContas"
                :value="data.item"
                @input="inputBanco(selectContas)"
                @change="data.toggleDetails"
              ></b-form-radio>
            </template>
            <template v-if="showNovaConta" #row-details="">
              <b-card>
                <div class="row d-flex">
                  <b-form-group label="Tipo da Conta " class="col-md-2">
                    <multiselect
                      placeholder="Selecione"
                      v-model="novaConta.selectTipoConta"
                      :options="optionTipoConta"
                      :allow-empty="false"
                      :show-labels="false"
                      label="nome"
                    />
                  </b-form-group>
                  <b-form-group label="Banco" class="col-md-3">
                    <multiselect
                      placeholder="Selecione"
                      v-model="novaConta.selectBancos"
                      :options="optionBancos"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="top"
                      label="nm_bco"
                      :custom-label="banco => banco ? `${banco.nm_bco} [${banco.cd_bco}]` : ''"
                    />
                  </b-form-group>
                  <b-form-group label="Nº Agência" class="col-md-1">
                    <b-form-input
                      type="number"
                      v-model="novaConta.nrAgencia"
                      min="1"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Nome Agência/Cidade" class="col-md-3">
                    <b-form-input v-model="novaConta.nmAgencia"></b-form-input>
                  </b-form-group>
                  <b-form-group label="Conta" class="col-md-2">
                    <b-form-input
                      v-model="novaConta.nrConta"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Digito" class="col-md-1">
                    <b-form-input
                      v-model="novaConta.nrDigito"
                      type="text"
                      :maxlength="dvMaxLength"
                      min="0"
                      @input="validateDigito"
                      @blur="$v.novaConta.nrDigito.$touch()"
                      :class="{
                        'is-invalid': $v.novaConta.nrDigito.$dirty && $v.novaConta.nrDigito.$invalid,
                        'is-valid': $v.novaConta.nrDigito.$dirty && !$v.novaConta.nrDigito.$invalid,
                      }"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="$v.novaConta.nrDigito.$dirty && $v.novaConta.nrDigito.$invalid">
                      O campo Digito é obrigatório.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </b-card>
            </template>
          </b-table>
        </div>
      </div>

      <div class="mt-3">
        <b-form-checkbox
          v-model="autorizacao"
          :value="true"
          :unchecked-value="false"
          plain
        >
          <span class="text-danger">
            Autorizo a Cooperativa de Trabalho dos Profissionais de Agronomia
            Ltda UNICAMPO, a efetuar o(s) crédito(s) que possuo junto a mesma,
            na opção assinalada acima.</span
          >
        </b-form-checkbox>
      </div>

      <div class="d-flex justify-content-end px-1 mt-3">
        <div class="me-2 align-self-center mt-1">
          <router-link to="/cooperado/liberacaoCredito">
            <b-button class="btn-danger"> Cancelar Operação </b-button>
          </router-link>
        </div>
        <div class="me-2 align-self-center mt-1">
          <b-button
            @click="inserirLiberacao()"
            class="btn-success"
            :disabled="!autorizacao || selectedCredito === '' || (selectedCredito !== 'I' && selectContas === '')"

          >
            Liberar Crédito(s)
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";

export default {
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Liberação de Créditos",
      items: [
        {
          text: "Liberação de Créditos",
          href: "/cooperado/liberacaoCredito",
          active: false,
        },
        {
          text: "Crédito Pendente",
        },
      ],
      camposLancamento: [
        {
          key: "sq_lcto",
          label: "Sequência",
        },
        {
          key: "cd_evento",
          label: "Tipo Documento",
        },
        {
          key: "nr_docto",
          label: "N° Documento",
        },
        {
          key: "ds_tp_natureza",
          label: "Natureza da Operação",
        },
        {
          key: "vl_lcto",
          class: "alinharCelulaDireita",
          label: "Valor",
        },
      ],
      tabelaLancamento: [
        {
          ds_mensagem_liberacao: "",
        },
      ],

      camposContas: [
        {
          key: "details",
          label: "",
        },
        {
          key: "cd_bco",
          label: "Código Banco",
        },
        {
          key: "nm_bco",
          label: "Nome Banco",
        },
        {
          key: "nr_agencia",
          label: "Nº Agência (Sem dígito)",
        },
        {
          key: "nm_agencia",
          label: "Natureza da Operação",
        },
        {
          key: "nr_cta",
          label: "Conta Bancária",
        },
        {
          key: "tp_conta",
          label: "Tipo Conta",
          formatter: (value) => {
            if (value == "C") {
              return "Conta Corrente";
            } else if (value == "C") {
              return "Poupança";
            }
          },
        },
        {
          key: "st_principal",
          label: "Principal",
          formatter: (value) => {
            if (value == "S") {
              return "Sim";
            } else if (value == "N") {
              return "Não";
            }
          },
        },
      ],
      tabelaContas: [],

      selectedCredito: "",
      selectContas: "",

      selectBancos: "",
      optionBancos: [],

      selectTipoConta: "",
      optionTipoConta: [
        { nome: "Conta Corrente", value: "C" },
        { nome: "Poupança", value: "P" },
      ],

      somaLancamentos: 0,
      showNovaConta: false,

      banco: {
        cd_bco: "",
        nr_agencia: "",
        nm_agencia: "",
        nr_cta: "",
        dv_cta: "",
        tp_conta: "",
        st_principal: "",
      },

      autorizacao: false,

      matricula: true,
      evento: true,

      novaConta: {
        selectBancos: "",
        selectTipoConta: "",
        nrAgencia: null,
        nmAgencia: null,
        nrConta: null,
        nrDigito: null,
      },
    };
  },
  computed: {
    dvMaxLength() {
      if (!this.novaConta.selectBancos || !this.novaConta.selectBancos.nm_bco) return 1;
      const nomeBanco = this.novaConta.selectBancos.nm_bco.toLowerCase();
      const bancosPermitidos = ["hsbc", "citibank", "agiplan", "agipag"];
      return bancosPermitidos.some(banco => nomeBanco.includes(banco)) ? 2 : 1;
    }
  },
  watch: {
    'novaConta.selectBancos'(newBanco) {
      if (!newBanco || !newBanco.nm_bco) {
        this.novaConta.nrDigito = "";
        return;
      }
      const nomeBanco = newBanco.nm_bco.toLowerCase();
      const bancosPermitidos = ["hsbc", "citibank", "agiplan", "agipag"];
      if (!bancosPermitidos.some(banco => nomeBanco.includes(banco))) {
        this.novaConta.nrDigito = "";
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.buscarLiberacaoCredito();
      this.buscarLiberacaoCreditoCooperado();
      this.buscarLiberacaoCreditoContaCoop();
      this.buscarBancos();
      this.buscarMatricula();
    }
  },
  validations: {
    novaConta: {
      nrDigito: {
        required: value => value !== null && value !== ""
      }
    }
  },
  methods: {
    buscarLiberacaoCredito() {
      this.$http
        .get(
          "api/contaCorrente/liberacaoCredito/buscarLiberacao/" +
            this.$route.params.id
        )
        .then((response) => {
          if (response.data && response.data.length > 0) {
            const liberacao = response.data[0];
            if (liberacao.ds_st_liberacao !== "Pendente") {
              this.$router.replace(
                "/cooperado/liberacaoCredito/creditoLiberado/" +
                  this.$route.params.id
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarLiberacaoCreditoCooperado() {
      this.$http
        .get(
          "api/contaCorrente/liberacaoCredito/buscarCooperado/" +
            this.$route.params.id
        )
        .then((response) => {
          if (response.data) {
            this.tabelaLancamento = response.data;
            this.somaValorLancamento(this.tabelaLancamento);
            this.tabelaLancamento.forEach((el) => {
              if (el.cd_evento == 300) {
                this.evento = false;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    validateDigito() {
      if (this.novaConta.nrDigito < 0) {
        this.novaConta.nrDigito = 0;
      }
    },

    buscarMatricula() {
      this.$http
        .get(
          "api/contaCorrente/liberacaoCredito/buscarMatricula/" +
            this.$route.params.id
        )
        .then((response) => {
          if (response.data && response.data.st_desligado == "S") {
            this.matricula = false;
            this.selectedCredito = "C";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    buscarLiberacaoCreditoContaCoop() {
      this.$http
        .get(
          "api/contaCorrente/liberacaoCredito/buscarContaCoop/" +
            this.$route.params.id
        )
        .then((response) => {
          if (response.data) {
            this.tabelaContas = response.data;
            this.tabelaContas.push({
              cd_bco: "Nova Conta",
              tp_conta: "",
              nm_agencia: "",
              nm_bco: "",
              nr_agencia: "",
              nr_cta: "",
              st_principal: "",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarBancos() {
      this.$http
        .get("api/contaCorrente/liberacaoCredito/buscarBancos")
        .then((response) => {
          if (response.data) {
            this.optionBancos = response.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async inserirLiberacao() {
      if (this.showNovaConta) {
        if (
          !this.novaConta.nrAgencia ||
          !this.novaConta.nrConta ||
          !this.novaConta.nrDigito ||
          !this.novaConta.nmAgencia ||
          !this.novaConta.selectBancos ||
          !this.novaConta.selectTipoConta
        ) {
          this.$tools.alerta(
            "Todas as informações bancárias são obrigatórias",
            "error"
          );
          return;
        }
        if (
          parseInt(this.novaConta.nrAgencia) <= 0 ||
          parseInt(this.novaConta.nrConta) <= 0 ||
          parseInt(this.novaConta.nrDigito) < 0
        ) {
          this.$tools.alerta(
            "Não é possível incluir agência ou conta menor ou igual a 0.",
            "error"
          );
          return;
        }
        this.banco.cd_bco = this.novaConta.selectBancos.cd_bco;
        this.banco.nr_agencia = this.novaConta.nrAgencia;
        this.banco.nm_agencia = this.novaConta.nmAgencia;
        this.banco.nr_cta = this.novaConta.nrConta;
        this.banco.dv_cta = this.novaConta.nrDigito;
        this.banco.tp_conta = this.novaConta.selectTipoConta.value;
        this.banco.st_principal = "N";
      }
      let msg = "";
      switch (this.selectedCredito) {
        case "I":
          msg =
            "Você tem certeza que deseja integralizar seu(s) Crédito(s) a sua Conta Capital?";
          break;
        case "C":
          msg =
            "Você tem certeza que deseja receber seu(s) Créditos(s) em conta bancária selecionada?";
          break;
        case "P":
          msg =
            "Você tem certeza que deseja receber seu(s) Crédito(s) parcial(is)?";
          break;
      }
      try {
        await this.$tools.alertaConfirm(msg);
      } catch {
        return;
      }
      this.$http
        .post("api/contaCorrente/liberacaoCredito/insereLiberacao", {
          sq_libera_credito: this.$route.params.id,
          tp_opcao: this.selectedCredito,
          cd_bco: this.banco.cd_bco,
          nr_agencia: this.banco.nr_agencia,
          nm_agencia: this.banco.nm_agencia,
          nr_cta: this.banco.nr_cta,
          dv_cta: this.banco.dv_cta,
          tp_conta: this.banco.tp_conta,
          st_principal: this.banco.st_principal,
        })
        .then((response) => {
          if (response.data) {
            var msgConfirm = "";
            if (this.selectedCredito == "I") {
              msgConfirm =
                "Seu(s) Crédito(s) será(ão) integralizado(s) a sua Conta Capital";
            } else {
              var data = new Date();
              data.setMonth(data.getMonth() + 1);
              if (this.selectedCredito == "C") {
                msgConfirm =
                  "Seu(s) Crédito(s) será(ão) Pago(s) em sua Conta Bancária até o dia " +
                  data.toLocaleString().substr(0, 10);
              } else {
                msgConfirm =
                  "50% do Seu(s) Crédito(s) será(ão) Pago(s) em sua Conta Bancária até o dia " +
                  data.toLocaleString().substr(0, 10);
                msgConfirm += " e 50% integralizado(s) a sua Conta Capital";
              }
            }
            this.$store.commit("ENVIAR_NOTIFICACAO", {
              notificacao: msgConfirm,
              icone: "success",
            });
            this.$router.push("/cooperado/liberacaoCredito");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$tools.alerta(err.response.data.message, "error");
        });
    },
    inputBanco(item) {
      if (item.cd_bco === "Nova Conta") {
        this.showNovaConta = true;
      } else {
        this.banco.cd_bco = item.cd_bco;
        this.banco.nr_agencia = item.nr_agencia;
        this.banco.nm_agencia = item.nm_agencia;
        this.banco.nr_cta = item.nr_cta;
        this.banco.dv_cta = item.dv_cta;
        this.banco.tp_conta = item.tp_conta;
        this.banco.st_principal = item.st_principal;
        this.showNovaConta = false;
      }
    },
    desabilitaAutorizacao() {
      this.autorizacao = false;
    },
    somaValorLancamento(item) {
      item.forEach((el) => {
        this.somaLancamentos += parseFloat(el.vl_lcto);
      });
    },
  },
};
</script>